import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { mktAttribution, mktLinks, apiError } from "../../../lib/adminApi";
import { Panel, Empty, PlanBadge, fmtDate, inputCls } from "../ui";

const STATUS = { active: ["Ativa", "text-emerald-300"], trialing: ["Em teste", "text-sky-300"], past_due: ["Pagamento pendente", "text-amber-300"], canceled: ["Cancelada", "text-slate-400"] };

export default function AttributionPanel() {
  const [users, setUsers] = useState(null);
  const [links, setLinks] = useState([]);
  const [filter, setFilter] = useState("");
  const [q, setQ] = useState("");

  useEffect(() => { mktLinks({ include_archived: 1 }).then((d) => setLinks(d.links || [])).catch(() => {}); }, []);
  useEffect(() => {
    mktAttribution(filter ? { link_key: filter, limit: 200 } : { limit: 200 }).then((d) => setUsers(d.users)).catch((e) => toast.error(apiError(e)));
  }, [filter]);

  const list = (users || []).filter((u) => !q || `${u.email} ${u.name} ${u.utm_campaign || ""} ${u.referrer || ""}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <Panel title="Cadastros e origem" testid="mkt-attribution"
      action={<div className="flex gap-2">
        <select value={filter} onChange={(e) => setFilter(e.target.value)} data-testid="mkt-attr-filter" className={`${inputCls} h-9 w-auto`}>
          <option value="">Todas as origens</option>
          <option value="organic">Orgânico / direto</option>
          {links.map((l) => <option key={l.id} value={l.id}>{l.name}</option>)}
        </select>
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar e-mail, nome…" data-testid="mkt-attr-search" className={`${inputCls} h-9 w-48`} />
      </div>}>
      {users && !list.length ? <Empty text="Nenhum cadastro com essa origem." /> : (
        <div className="rounded-2xl ring-1 ring-white/[0.06] overflow-hidden"><div className="overflow-x-auto">
          <table className="w-full text-[12.5px]">
            <thead className="bg-white/[0.03] text-[10.5px] uppercase tracking-wider text-slate-400">
              <tr>{["Usuário", "Cadastro", "Origem", "Campanha", "Entrada", "Plano", "Assinatura", "1º pagamento"].map((h) => <th key={h} className="px-3 py-2.5 text-left font-medium">{h}</th>)}</tr>
            </thead>
            <tbody className="divide-y divide-white/[0.05]">
              {list.map((u) => {
                const st = STATUS[u.subscription_status] || null;
                return (
                  <tr key={u.user_id} data-testid={`mkt-attr-row-${u.user_id}`} className="hover:bg-white/[0.02]">
                    <td className="px-3 py-2.5"><div className="text-white">{u.name || "—"}</div><div className="text-[11px] text-slate-500">{u.email}</div></td>
                    <td className="px-3 py-2.5 text-slate-300 whitespace-nowrap">{fmtDate(u.created_at, true)}</td>
                    <td className="px-3 py-2.5">
                      {u.link_key !== "organic" ? <span className="text-[#7DD3FC]">{u.link_name || u.link_key}</span> : <span className="text-slate-400">{u.utm_source || u.referrer || "direto"}</span>}
                    </td>
                    <td className="px-3 py-2.5 text-slate-400">{u.utm_campaign || "—"}{u.utm_medium ? <span className="text-slate-600"> · {u.utm_medium}</span> : null}</td>
                    <td className="px-3 py-2.5 text-slate-500 font-mono-jb text-[11px]">{u.landing_path || "—"}</td>
                    <td className="px-3 py-2.5"><PlanBadge plan={u.plan} /></td>
                    <td className="px-3 py-2.5">{st ? <span className={st[1]}>{st[0]}</span> : <span className="text-slate-600">—</span>}{u.lookup_key && <div className="text-[11px] text-slate-500">{u.lookup_key}</div>}</td>
                    <td className="px-3 py-2.5 text-slate-300 whitespace-nowrap">{u.first_paid_at ? fmtDate(u.first_paid_at) : <span className="text-slate-600">—</span>}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div></div>
      )}
    </Panel>
  );
}
